import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';

interface AppUrlsResponse {
  url_appstore?: string;
  url_playstore?: string;
  ios?: string;
  android?: string;
}

@Component({
  selector: 'mvp-update-modal',
  templateUrl: './update-modal.component.html',
})
export class UpdateModalComponent implements OnInit {
  storeUrl: string | null = null;

  constructor(private http: HttpClient, private platform: Platform) { }

  ngOnInit() {
    this.http.get<AppUrlsResponse>(`${environment.apiUrl}/application/${environment.application}/urls`).subscribe(urls => {
      this.storeUrl = this.getStoreUrl(urls);
    });
  }

  onUpdateClick() {
    if (this.storeUrl) {
      window.open(this.storeUrl, '_blank');
    }
  }

  onCancelClick() {
    const modal = document.getElementById('updateModal');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  private getStoreUrl(urls: AppUrlsResponse): string | null {
    if (this.platform.is('ios')) {
      return urls.url_appstore || urls.ios || null;
    }

    if (this.platform.is('android')) {
      return urls.url_playstore || urls.android || null;
    }

    return null;
  }
}
